import { gql } from "@apollo/client";

export const GET_STATIONS = gql`
    query Tags_data {
        tags_data(clients: ["secretaria-de-defesa-civil"]) {
            qualle_meteorologia {
                codigo
                type
                name {
                    prefix
                    general
                    local
                }
                show
                data {
                    senstermica {
                        atual {
                            value
                        }
                    }
                    temperatura {
                        atual {
                            value
                        }
                    }
                    umidade {
                        atual {
                            value
                        }
                    }
                    rio {
					    rio_nivel {
						    value
					    }
				    }
                    vento {
					    velocidade_media {
						    value						
					    }
					    direcao {
						    value
					    }
				    }
                    pressaoatmos {
					    atual {
						    value
					    }
				    }
                    chuva {
					    acumulado {
						    min005 {
							    value
						    }
						    h001 {
							    value
						    }
						    h003 {
							    value
						    }
                            h006 {
							    value
						    }
                            h012 {
							    value
						    }
                            h024 {
							    value
						    }
                            h024 {
							    value
						    }
                            h048 {
							    value
						    }
                            h072 {
							    value
						    }
                            h096 {
							    value
						    }
                            h120 {
							    value
						    }
                            h144 {
							    value
						    }
                            h168 {
							    value
						    }
					    }
				    }
                }
            }
        }
    }
`;
